import {
  GET_ATTACHMENT_CATEGORY_TYPE_DATA,
  GET_ATTACHMENT_CATEGORY_TYPE_DATA_SUCCESS,
  GET_ATTACHMENT_CATEGORY_TYPE_DATA_FAIL,
  ADD_ATTACHMENT_CATEGORY_TYPE,
  ADD_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  ADD_ATTACHMENT_CATEGORY_TYPE_FAIL,
  UPDATE_ATTACHMENT_CATEGORY_TYPE,
  UPDATE_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  UPDATE_ATTACHMENT_CATEGORY_TYPE_FAIL,
  DELETE_ATTACHMENT_CATEGORY_TYPE,
  DELETE_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  DELETE_ATTACHMENT_CATEGORY_TYPE_FAIL,
} from "./actionTypes";

// ***** Attachment Category Type Action Creators *****
//Get Attachment Category Type List
export const getAttachmentCategoryTypeData = () => ({
  type: GET_ATTACHMENT_CATEGORY_TYPE_DATA,
});
// Attachment Category Type data success
export const getAttachmentCategoryTypeDataSuccess = (data) => ({
  type: GET_ATTACHMENT_CATEGORY_TYPE_DATA_SUCCESS,
  payload: data,
});

// Attachment Category Type data fail
export const getAttachmentCategoryTypeDataFail = (error) => ({
  type: GET_ATTACHMENT_CATEGORY_TYPE_DATA_FAIL,
  payload: error,
});

// Create New Attachment Category Type
export const addNewAttachmentCategoryType = (attachmentCategoryType) => ({
  type: ADD_ATTACHMENT_CATEGORY_TYPE,
  payload: attachmentCategoryType,
});

// Create New Attachment Category Type Success
export const addAttachmentCategoryTypeSuccess = (attachmentCategoryType) => ({
  type: ADD_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  payload: attachmentCategoryType,
});

// Create New Attachment Category Type Fail
export const addAttachmentCategoryTypeFail = (error) => ({
  type: ADD_ATTACHMENT_CATEGORY_TYPE_FAIL,
  payload: error,
});

// Delete Attachment Category Type
export const deleteAttachmentCategoryType = (attachmentCategoryType) => ({
  type: DELETE_ATTACHMENT_CATEGORY_TYPE,
  payload: attachmentCategoryType,
});

// Delete Attachment Category Type Success
export const deleteAttachmentCategoryTypeSuccess = (
  attachmentCategoryType
) => ({
  type: DELETE_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  payload: attachmentCategoryType,
});

// Delete Attachment Category Type Fail
export const deleteAttachmentCategoryTypeFail = (error) => ({
  type: DELETE_ATTACHMENT_CATEGORY_TYPE_FAIL,
  payload: error,
});

// Update Attachment Category Type
export const updateAttachmentCategoryType = (attachmentCategoryType) => ({
  type: UPDATE_ATTACHMENT_CATEGORY_TYPE,
  payload: attachmentCategoryType,
});

// Update Attachment Category Type Success
export const updateAttachmentCategoryTypeSuccess = (
  attachmentCategoryType
) => ({
  type: UPDATE_ATTACHMENT_CATEGORY_TYPE_SUCCESS,
  payload: attachmentCategoryType,
});

// Update Attachment Category Type Fail
export const updateAttachmentCategoryTypeFail = (error) => ({
  type: UPDATE_ATTACHMENT_CATEGORY_TYPE_FAIL,
  payload: error,
});
